module.exports = __webpack_public_path__ + "img/sort.1f88a6e8.svg";